// TODO: add the remainder of z-index.scss styles
const informationalBanner = 350;
const stickyBanner =  210;


export default {
  informationalBanner,
  stickyBanner
}
